import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Card, CardBody, Col, Container, Row, Button, Label, CardText, CardTitle, ButtonGroup, Input, Modal } from 'reactstrap';
import notify from '../../../custom/helpers/Notify';
import '../../../pages/Tables/datatables.scss';
import { ActionButtons } from '../../../custom/components/ActionButtons';
import { ConfirmDialog } from '../../../custom/components/ConfirmDialog';
import { pageState, lastAPIActionTimeState, pageWebsocketsEnabledState, themeTypeState } from '../../../state/GlobalState';
import { HasPermission } from '../../../custom/helpers/HasPermission';
import { DynamicModal } from '../../../custom/components/DynamicModal';
import { cloneDeep, get,set } from 'lodash';
import Flatpickr from "react-flatpickr"
import { mergeOperationalDateCaps } from '../../../utils/flatpickrOperational';
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import { getDataListRequest, updateDataRequest, deleteDataRequest, sendAirlineMailRequest, isDisplayedRequest, getClaimTypeListRequest, getAddressListRequest, getDamageBagClaimListRequest, getForwardTypeListRequest, getDPRActionListRequest, getBagStatusListRequest, closeCaseRequest, reopenCaseRequest } from '../../../api/controller/CaseFileController';
import { getSignatureDataRequest } from '../../../api/controller/BagController'; // CHANGE (controller name)
import { CustomerInfoModal } from '../customerInfos/CustomerInfoDetails';
import { formModes, filtersDefault, modalConfigDefault, caseFileDataStructureState as dataStructureState, caseFileListState as dataListState, caseFileClaimTypeState, caseFileAddressState, caseFileDamageBagClaimState, caseFileForwardTypeState, caseFileDPRActionState, caseFileBagStatusState, caseFileCustomerInfoLink, } from './state'; // CHANGE (dataList & structure stateName)
import { Loader } from '../../../custom/components/Loader';
import echo from '../../../api/core/echo';
import { handleSocket, handleGridSocket } from '../../../custom/helpers/HandleSocket';
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { handleResponse } from '../../../custom/helpers/HandleResponse';
import SelectEditor from "../../../custom/components/grid/SelectEditor"
import DefaultEditor from "../../../custom/components/grid/DefaultEditor"
import MaskEditor from "../../../custom/components/grid/MaskEditor"
import DateTimeEditor from "../../../custom/components/grid/DateTimeEditor"
import RadioEditor from "../../../custom/components/grid/RadioEditor"
import CheckboxEditor from "../../../custom/components/grid/CheckboxEditor"
import SwitchEditor from "../../../custom/components/grid/SwitchEditor"
import moment from "moment";
import useBreakpoint from '../../../custom/components/hooks/useBreakpoint';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import logo from '../../../assets/images/logo-dark.png';
import { CaseFileViewModal } from './CaseFileViewModal';
import {
    CaseFileReceiveAllModal,
    CaseFileForwardAllModal,
    CaseFileDeliverAllModal,
} from './CaseFileBulkActionModals';

const CaseFiles = ({ isDashboard=false, location, history }) => {
  
  const model = 'Case File' // CHANGE
  const models = 'Case Files' // CHANGE
  
  // GET & SET SELECTS
  const selects = [
    { model: 'ClaimType', getFn: getClaimTypeListRequest, setFn: useSetRecoilState(caseFileClaimTypeState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
		{ model: 'Address', getFn: getAddressListRequest, setFn: useSetRecoilState(caseFileAddressState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
		{ model: 'DamageBagClaim', getFn: getDamageBagClaimListRequest, setFn: useSetRecoilState(caseFileDamageBagClaimState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
		{ model: 'ForwardType', getFn: getForwardTypeListRequest, setFn: useSetRecoilState(caseFileForwardTypeState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
		{ model: 'Action', wsDisabled: true, getFn: getDPRActionListRequest, setFn: useSetRecoilState(caseFileDPRActionState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
		{ model: 'BagStatus', getFn: getBagStatusListRequest, setFn: useSetRecoilState(caseFileBagStatusState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
		
    // { model: 'ModelName', getFn: getModelListRequest, setFn: useSetRecoilState(modelState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
  ]
  const modalView = true // SET TO false IF ALL COLUMNS EDITABLE ON TABLE
  const modalEdit = true // SET TO false IF ALL COLUMNS EDITABLE ON TABLE
  const modalDelete = true
  const defaultColDef = {
    sortable: true,
    editable: true,
    valueSetter: async(e) => {
      let tempRow = { id: e.data.id }
      let s = ['select','multiselect']
      dataStructure.filter(i=>i.table?.editable).forEach((input) => {        
        let v = e.newValue
        if((e.column.colDef?.cellEditorParams?.fieldName || e.column.colId) !== getFN(input)){
          if(Array.isArray(e.data[getFN(input)])){
            v = e.data[getFN(input)].map(i=>s.includes(input.type) ? (i[input.subFields?.value || "id"] || i) : i)
          } else if(s.includes(input.type)){
            v = e.data[getFN(input)][input.subFields?.value || "id"] || e.data[getFN(input)]
          } else if(input.type === 'datepicker' && input.table?.postDateFormat){
            v = moment(e.data[getFN(input)]).format(input.table?.postDateFormat)
          } else {
            v = e.data[getFN(input)]
          }
        } else {
          if(input.type === 'datepicker' && input.table?.postDateFormat){
            v = moment(v).format(input.table?.postDateFormat)
          }
        }
        tempRow = {...tempRow, [getPN(input)]: v }
      })
      const response = await updateDataRequest({...tempRow})
      handleResponse(response)
    },
  }
  
  const [ovf, _setOvf] = useState(false);
  const ovfRef = useRef(ovf);
  const setOvf = data => {
    ovfRef.current = data;
    _setOvf(data);
  }
  const [dataList, setDataList] = useRecoilState(dataListState);
  // eslint-disable-next-line
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [gridApi, _setGridApi] = useState(null);
  const gridApiRef = useRef(gridApi)
  const setGridApi = data => {
    gridApiRef.current = data;
    _setGridApi(data)
  }
  const [pageWebsocketsEnabled, setPageWebsocketsEnabled] = useRecoilState(pageWebsocketsEnabledState)
  const setPage = useSetRecoilState(pageState)
  const [lastAPIActionTime, setLastAPIActionTime] = useRecoilState(lastAPIActionTimeState)
  const [tableLoading, setTableLoading] = useState(true)
  const themeType = useRecoilValue(themeTypeState)
  const [mobileSearchFilter, setMobileSearchFilter] = useState('')	
  const [searchValue, setSearchValue] = useState('')	
  const searchValueRef = useRef(searchValue)
	
  const [confirmModalVisible, setConfirmModalVisible] = useState(false)
  const [confirmID, setConfirmID] = useState(null);
  const [confirmParams, setConfirmParams] = useState({});
  const [confirmConfig, setConfirmConfig] = useState({ fn: null, title: null, body: null });
  const [cuModalConfig, _setCUModalConfig] = useState({visible: false, header: model, type: null, typeKey: null, data: {}, ...modalConfigDefault})
  const cuModalConfigRef = useRef(cuModalConfig)
  const setCUModalConfig = data => {
    cuModalConfigRef.current = data;
    _setCUModalConfig(data)
  }
  const [actionsDisabled, setActionsDisabled] = useState(true)
  const [primaryChannel, setPrimaryChannel] = useState(null)
  const listRequestPayloadRef = useRef({})
  const [filters, setFilters] = useState(filtersDefault)
  const dataStructure = useRecoilValue(dataStructureState)
  const [selectedRow, setSelectedRow] = useState(null)
  
  const breakPoint = useBreakpoint()
  const [xsFData, setXsFData] = useState([])
  const [xsPageSize] = useState(10)
  const [xsCurrentPage, setXsCurrentPage] = useState(1)
  const [xsMaxPage, setXsMaxPage] = useState(1)

  const [parseModalVisible, setParseModalVisible] = useState(false)
  const [parseData, setParseData] = useState('')

  const addresses = useRecoilValue(caseFileAddressState)

  const [receiptModalVisible, setReceiptModalVisible] = useState(false)
  const [receiptModalData, setReceiptModalData] = useState({})

  const [mailAirlineModalVisible, setMailAirlineModalVisible] = useState(false)
  const [mailAirlineRow, setMailAirlineRow] = useState(null)
  const [mailAirlineCustomMessage, setMailAirlineCustomMessage] = useState('')

  const [caseFileViewOpen, setCaseFileViewOpen] = useState(false)
  const [caseFileViewRow, setCaseFileViewRow] = useState(null)
  const [customerInfoPopup, setCustomerInfoPopup] = useState(null)
  const caseFileViewSyncRef = useRef({ open: false, id: null })

  const withBagSignatures = useCallback(async (row) => {
    if (!row?.bags?.length) return row
    const bags = await Promise.all(row.bags.map(async (bag) => {
      if (!bag.delivery_signature) return bag
      const res = await getSignatureDataRequest({ id: bag.id })
      if (res?.Status === 'success') return { ...bag, delivery_signature_data: res.Data }
      return bag
    }))
    return { ...row, bags }
  }, [])

  const [bulkCaseAction, setBulkCaseAction] = useState(null) // { type: 'receive'|'forward'|'deliver', row }
  const forwardTypeList = useRecoilValue(caseFileForwardTypeState)
  const forwardTypeOptions = useMemo(
    // Select list API stores `{ label, value }` (see fetchSelectData); do not map `.name`/`.id` again.
    () => (forwardTypeList?.data || []).map(x => ({
      label: x.label ?? x.name,
      value: x.value ?? x.id,
    })),
    [forwardTypeList],
  )

  const openBulkCaseAction = ({ row, type }) => {
    if (!row?.id || !type) return
    setBulkCaseAction({ type, row })
  }
  const closeBulkCaseAction = () => setBulkCaseAction(null)
  const onBulkCaseActionSuccess = (res) => {
    handleResponse(res)
    if (res?.Status === 'success' && !pageWebsocketsEnabled) {
      setLastAPIActionTime(new Date())
    }
    closeBulkCaseAction()
  }
  const openCaseFileView = async ({ row }) => {
    if (!row) return
    const enriched = await withBagSignatures(cloneDeep(row))
    setCaseFileViewRow(enriched)
    setCaseFileViewOpen(true)
  }
  const closeCaseFileView = () => {
    setCaseFileViewOpen(false)
    setCaseFileViewRow(null)
  }

  useEffect(() => {
    caseFileViewSyncRef.current = { open: caseFileViewOpen, id: caseFileViewRow?.id ?? null }
  }, [caseFileViewOpen, caseFileViewRow?.id])

  const toggleParseModal = () => setParseModalVisible(!parseModalVisible)

  useEffect(() => {
    setPage((models.charAt(0).toLowerCase() + models.slice(1)).split(" ").join(""))
    setPageWebsocketsEnabled(process.env.REACT_APP_WEBSOCKETS_ENABLED === 'true')
  }, [setPage, setPageWebsocketsEnabled])

  

  // useEffect(() => {
    // if(cuModalConfig.visible){
      // let temp = renderToString(<DynamicModal config={cuModalConfig} toggleModal={toggleCUModal} submitModes={formModes} ds={dataStructure} />)
      // console.log(temp)
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [cuModalConfig])


  useEffect(() => {
    async function fetchData(filter){
      setTableLoading(true)
      setDataList([])
      const response = await getDataListRequest(filter);
      if(response && response.Status !== 'error'){
        setDataList(response.data)
        response.ovf ? setOvf(true) : setOvf(false)
      } else {
        notify({ status: 'error', message: response.Message })
      }	
      searchValueRef.current = searchValue;	
      setTableLoading(false)
    }
    let fetch = true
    let postData = {}
    if(filters.length > 0){
      filters.forEach((filter)=>{
        fetch = filter.value.length === 0 && filter.required ? false : fetch
        if(filter.value){
          set(postData, filter.name || filter.label.replace(/ /g, ''), filter.type === "select" ? filter.value.value : filter.value)
        }
      })	
    }	
    if(ovf){	
      set(postData, 'SearchQuery', searchValue)
    }
    if(isDashboard){
      set(postData, 'Dashboard', true)
    }
    if(fetch){	
      listRequestPayloadRef.current = postData
      fetchData(postData)	
    }
    if(pageWebsocketsEnabled){
      const channelFilters = Object.keys(postData).filter((k)=>k !== "SearchQuery" && k !== "Period" && k !== "Dashboard").length > 0 ? "." + Object.keys(postData).filter((k)=>k !== "SearchQuery" && k !== "Period" && k !== "Dashboard").map((val)=>(postData[val].toString())).join(".") : ""
      const channelToSub = `${model.replace(/ /g, '')}${isDashboard ? "Dash" : ""}-Primary${channelFilters}`
      if(primaryChannel !== channelToSub){
        if(primaryChannel){
          echo.leave(primaryChannel)
        }
        setPrimaryChannel(channelToSub)
        echo.private(channelToSub).listen(`.${model.replace(/ /g, '')}${isDashboard ? "Dash" : ""}Events`, (data) => {
          handleGridSocket(data, gridApiRef.current, setGridApi, (ovfRef.current ? ((payload) => isDisplayedRequest({ ...listRequestPayloadRef.current, id: payload.id, SearchQuery: payload.SearchQuery })) : false), searchValueRef.current)
          if(data.from !== echo.socketId() && cuModalConfigRef.current.visible === true && cuModalConfigRef.current.type === "Update" && parseInt(cuModalConfigRef.current.data.id) === parseInt(data.data.id) && data.event === "Updated"){
            setCUModalConfig({...cuModalConfigRef.current, expired: true})
          }
          if (data.event === "Updated" && data.data?.id != null) {
            const v = caseFileViewSyncRef.current
            if (v.open && v.id != null && parseInt(v.id) === parseInt(data.data.id)) {
              withBagSignatures(cloneDeep(data.data)).then(setCaseFileViewRow)
            }
            setDataList((currentData) => {
              if (!Array.isArray(currentData)) return currentData
              const incomingID = data.data.id
              const idx = currentData.findIndex((i) => parseInt(i.id) === parseInt(incomingID))
              if (idx === -1) return currentData
              const copy = [...currentData]
              copy[idx] = data.data
              return copy
            })
          }
          if (data.event === "Deleted") {
            const deletedId = data.data
            setDataList((currentData) => {
              if (!Array.isArray(currentData)) return currentData
              return currentData.filter((i) => parseInt(i.id) !== parseInt(deletedId))
            })
            const v = caseFileViewSyncRef.current
            if (v.open && v.id != null && parseInt(v.id) === parseInt(deletedId)) {
              setCaseFileViewOpen(false)
              setCaseFileViewRow(null)
            }
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [lastAPIActionTime, filters, pageWebsocketsEnabled]);

  useEffect(() => {
    async function fetchSelectData(){
      setActionsDisabled(true)
      await Promise.all(selects.map(async(select)=>{
        if(! (select.persist && select.read?.length > 0)){
          const response = await select.getFn();
          const setFnRef = data => {
            select.ref.current = data
            select.setFn(data)
          }
          if(pageWebsocketsEnabled && !select.wsDisabled){
            echo.private(`${select.model}-Select`).listen(`.${select.model}Events`, (data) => {
              handleSocket(select.ref.current, data, setFnRef, select.keys || { label: "name", value: "id" })
            });
          }
          if(response && response.Status !== 'error'){	
            setFnRef({ ovf: response.ovf, data: (select.exactValue ? response.data : response.data?.map((val)=>({ label: val[select.keys.label || "name"], value: val[select.keys.value || "id"] }))) })	
          } else {	
            notify({ status: 'error', message: response.Message });	
          }
        }
      }))
      setActionsDisabled(false)
    }
    fetchSelectData();
    return () => {
      setDataList([])
      if(pageWebsocketsEnabled){
        echo.leave(primaryChannel)
      }
      selects.filter(s=>!(s.persist && s.read?.length > 0)).forEach((s)=>{
        s.ref.current = []
        s.setFn([])
        if(pageWebsocketsEnabled && !s.wsDisabled){
          echo.leave(`${s.model}-Select`)
        }
      })
    }
    // eslint-disable-next-line
  }, [])

  const toggleCUModal = async ({row={}, mode=null, modeKey=0, size=null, wizard=null, customHeader=false, printName=false, print=false}) => {
    caseFileCustomerInfoLink.id = null
    const enriched = (mode === 'Update' || mode === 'View') ? await withBagSignatures(row) : row;
    setCUModalConfig({ ...cuModalConfig, visible: !cuModalConfig.visible, type: typeof(mode) === 'string' ? mode : null, typeKey: modeKey, data: enriched, size: size || cuModalConfig.size, wizard: wizard !== null ? wizard : cuModalConfig.wizard, customHeader: customHeader, printName: printName, print:print, preloadData: false, linkedCustomerInfo: null })
  }

  const toggleConfirmModal = ({row={}, params={}, request=null, title=null, body=null}) => {
    setConfirmID(row ? row.id : null)
    setConfirmParams(params)
    setConfirmConfig({ fn: request, title: title, body: body })
    setConfirmModalVisible(! confirmModalVisible)
  }
  const getPN = (val) => {
    return val.name || val.label.replace(/ /g, '')
  }
  
  const getFN = (val) => {
    return val.field || val.label.replace(/ /g, '_').toLowerCase()
  }

  const toggleReceiptModal = (row) => {
    if(receiptModalVisible){
      setReceiptModalVisible(false)
      // setReceiptModalData({})
    } else {
      setReceiptModalVisible(true)
      setReceiptModalData(row)
    }
    console.log(receiptModalData)
  }

  const openMailAirlineModal = ({ row }) => {
    if (!row?.id) return
    setMailAirlineRow(row)
    setMailAirlineCustomMessage('')
    setMailAirlineModalVisible(true)
  }

  const closeMailAirlineModal = () => {
    setMailAirlineModalVisible(false)
    setMailAirlineRow(null)
    setMailAirlineCustomMessage('')
  }

  const sendMailAirline = async () => {
    if (!mailAirlineRow?.id) return
    const response = await sendAirlineMailRequest({ id: mailAirlineRow.id, CustomMessage: mailAirlineCustomMessage })
    handleResponse(response)
    if (response?.Status === 'success' && !pageWebsocketsEnabled) {
      setLastAPIActionTime(new Date())
    }
    closeMailAirlineModal()
  }

  const actionListType = 'menu' // CHANGE
  /** Distinct toolbar colors + compact labels (case file row actions). */
  const xsActions = useMemo(() => ([
    {
      label: 'Update',
      shortLabel: 'Edit',
      permission: 'update',
      icon: 'mdi mdi-pencil',
      color: 'success',
      customButtonStyle: { backgroundColor: '#4f46e5', borderColor: '#4338ca', color: '#ffffff' },
      fn: toggleCUModal,
      params: { mode: "Update", print: false, size: "xl" }
    },
    {
      label: 'Receive All',
      shortLabel: 'Receive All',
      permission: ':receive-caseFiles',
      icon: 'mdi mdi-bag-suitcase',
      color: 'info',
      customButtonStyle: { backgroundColor: '#0d9488', borderColor: '#0f766e', color: '#ffffff' },
      fn: openBulkCaseAction,
      params: { type: 'receive' }
    },
    {
      label: 'Forward All',
      shortLabel: 'Forward All',
      permission: ':forward-caseFiles',
      icon: 'mdi mdi-fast-forward',
      color: 'warning',
      customButtonStyle: { backgroundColor: '#ea580c', borderColor: '#c2410c', color: '#ffffff' },
      fn: openBulkCaseAction,
      params: { type: 'forward' }
    },
    {
      label: 'Deliver All',
      shortLabel: 'Deliver All',
      permission: ':deliver-caseFiles',
      icon: 'mdi mdi-check',
      color: 'success',
      customButtonStyle: { backgroundColor: '#059669', borderColor: '#047857', color: '#ffffff' },
      fn: openBulkCaseAction,
      params: { type: 'deliver' }
    },
    {
      label: 'Create Note',
      shortLabel: 'Create Note',
      permission: 'update',
      icon: 'mdi mdi-note',
      color: 'success',
      customButtonStyle: { backgroundColor: '#475569', borderColor: '#334155', color: '#ffffff' },
      fn: toggleCUModal,
      params: { mode: "Update", modeKey: 1, size: "md", print: false }
    },
    {
      label: 'Mail Airline',
      shortLabel: 'Mail Airline',
      permission: ':mail-caseFiles',
      icon: 'mdi mdi-email',
      color: 'info',
      customButtonStyle: { backgroundColor: '#0284c7', borderColor: '#0369a1', color: '#ffffff' },
      fn: openMailAirlineModal,
      params: {}
    },
    {
      label: 'Close Case',
      shortLabel: 'Close Case',
      icon: 'mdi mdi-close-circle-outline',
      color: 'info',
      customButtonStyle: { backgroundColor: '#57534e', borderColor: '#44403c', color: '#ffffff' },
      fn: toggleConfirmModal,
      params: { request: closeCaseRequest }
    },
    {
      label: 'Reopen Case',
      shortLabel: 'Reopen Case',
      permission: ':reopen-caseFiles',
      icon: 'mdi mdi-lock-open-outline',
      color: 'info',
      customButtonStyle: { backgroundColor: '#65a30d', borderColor: '#4d7c0f', color: '#ffffff' },
      fn: toggleConfirmModal,
      params: { request: reopenCaseRequest }
    },
    {
      label: 'View',
      shortLabel: 'View',
      permission: 'read',
      icon: 'mdi mdi-eye',
      color: 'primary',
      customButtonStyle: { backgroundColor: '#2563eb', borderColor: '#1d4ed8', color: '#ffffff' },
      fn: openCaseFileView,
      params: {}
    },
    {
      label: 'Receipt',
      shortLabel: 'Receipt',
      permission: 'read',
      icon: 'mdi mdi-receipt',
      color: 'primary',
      customButtonStyle: { backgroundColor: '#a21caf', borderColor: '#86198f', color: '#ffffff' },
      fn: toggleReceiptModal,
    },
    {
      label: 'Delete',
      shortLabel: 'Delete',
      permission: 'delete',
      icon: 'mdi mdi-trash-can',
      color: 'danger',
      customButtonStyle: { backgroundColor: '#dc2626', borderColor: '#b91c1c', color: '#ffffff' },
      fn: toggleConfirmModal,
      params: { request: deleteDataRequest }
    },
    // eslint-disable-next-line
  ]), []);

  // eslint-disable-next-line
  const actions = useMemo(() => xsActions.filter(e=>(e.label === 'Update' && modalEdit) || (e.label === 'Close Case') || (e.label === 'Reopen Case') || (e.label === "Receive All") || (e.label === "Forward All") || (e.label === "Deliver All") || (e.label === "Create Note") || (e.label === "Mail Airline") || (e.label === "Reset" && modalEdit) || (e.label === 'Delete' && modalDelete) || (e.label === 'View' && modalView) || (e.label === 'Receipt')), [xsActions])
  
  const isCaseClosable = (row) => {
    if (!row || row.closed) return false
    if (typeof row.closable === 'boolean') return row.closable
    const bags = row.bags
    if (!Array.isArray(bags)) return false
    return !bags.some((b) => Number(b.bag_status_id) === 3)
  }

  const isCaseReceivable = (row) => {
    if (!row || row.closed) return false
    if (typeof row.receivable === 'boolean') return row.receivable
    const bags = row.bags
    if (!Array.isArray(bags)) return false
    return bags.some((b) => [1, 2, 9].includes(Number(b.bag_status_id)))
  }

  /** Forward All / Deliver All share backend rules (all bags received + at least one in RECEIVED). */
  const isCaseForwardOrDeliverEligible = (row) => {
    if (!row || row.closed) return false
    if (typeof row.deliverable === 'boolean') return row.deliverable
    if (typeof row.forwardable === 'boolean') return row.forwardable
    const bags = row.bags
    if (!Array.isArray(bags)) return false
    if (bags.some((b) => b.receive_date == null || b.receive_date === '')) return false
    return bags.some((b) => Number(b.bag_status_id) === 3)
  }

  const getFilteredCaseFileActions = (row, actionList = false) => {
    const source = actionList ? actionList : actions
    return source.filter((e) => (
      (e.label === "Receipt") ||
      ((e.label === "Forward All" || e.label === "Deliver All") && isCaseForwardOrDeliverEligible(row)) ||
      (e.label === "Receive All" && isCaseReceivable(row)) ||
      (e.label === "Close Case" && isCaseClosable(row)) ||
      (e.label === "Reopen Case" && row.closed) ||
      (e.label === "Delete" && !row.closed) ||
      (e.label === "Update" && !row.closed) ||
      e.label === "View" ||
      e.label === "Create Note" ||
      e.label === "Mail Airline"
    ))
  }

  const renderActions = (row, grouped=false, actionList=false, showActionLabels=false) => <ActionButtons key={row.id} actions={getFilteredCaseFileActions(row, actionList)} type={grouped ? 'buttons' : actionListType} row={row} grouped={grouped} showLabels={showActionLabels} actionsDisabled={actionsDisabled} printName={`Receipt-${row.reference}`} customHeader={`Case File | {rowlabel} | ${row.reference} - ${row.flight} - ${row.type}`} />
  
  const valueGetter = (data, input) => {
    if (input.label === "Reference") {
      const ref =
        data.reference != null && String(data.reference).trim() !== ""
          ? String(data.reference).trim()
          : "";
      const fileRefSecondary =
        data.file_reference != null && String(data.file_reference).trim() !== ""
          ? String(data.file_reference).trim()
          : "";
      const parts = [fileRefSecondary, ref].filter(Boolean);
      if (parts.length) return parts.join(" · ");
      const fallback =
        data.primary_reference != null && String(data.primary_reference).trim() !== ""
          ? String(data.primary_reference).trim()
          : "";
      return fallback;
    }
    if(input.label === "Case Status"){
      const status = data.case_status != null && data.case_status !== '' ? String(data.case_status) : '—'
      const rec = Number(data.number_of_received_bags ?? 0)
      const tot = Number(data.number_of_bags ?? 0)
      const ratio = Number.isFinite(tot) ? `${rec}/${tot}` : '—'
      const lock = data.closed ? ' · Closed' : ''
      const type = data.type != null && data.type !== '' ? String(data.type) : '—'
      return `${type} · ${status} · ${ratio}${lock}`
    }
    if(input.label === "Flight"){
      const f = data.flight != null && data.flight !== '' ? String(data.flight) : ''
      const d = data.flight_date ? moment(data.flight_date).format('DD-MMM-YY') : ''
      if(f && d){ return `${f} · ${d}` }
      return f || d || ''
    }
    if(input.label === "First name"){
      return data.full_name != null && data.full_name !== '' ? String(data.full_name) : ''
    }
    if(input.type === 'checkbox'){
      return (parseInt(data[getFN(input)]) === 1 || data[getFN(input)] === true) ? "Yes" : ((parseInt(data[getFN(input)]) === 0 || data[getFN(input)] === false) ? "No" : "")	
    } else if(input.type === 'switch'){
      return (parseInt(data[getFN(input)]) === 1 || data[getFN(input)] === true) ? (input.list && input.list[0] ? input.list[0] : "Yes") : ((parseInt(data[getFN(input)]) === 0 || data[getFN(input)] === false) ? (input.list && input.list[1] ? input.list[1] : "No") : "")
    } else if((input.type === 'select' || input.type === 'multiselect' || input.type === 'nestedselect') && !input.rootValue){
      return data[getFN(input)] ? data[getFN(input)][input.subFields?.label || "name"] : ""
    } else if(input.type === 'datepicker' && input.table?.dateFormat){
      return data[getFN(input)] ? moment(data[getFN(input)]).format(input.table.dateFormat) : null
    } else {
      return data[getFN(input)]
    }
  }

  const cellEditor = (type) => {
    switch(type){
      case 'checkbox':
        return 'CheckboxEditor'
      case 'switch':
        return 'SwitchEditor'
      case 'datepicker':
        return 'DateTimeEditor'
      case 'select':
        return 'SelectEditor'
      case 'multiselect':
        return 'SelectEditor'
      case 'mask':
        return 'MaskEditor'
      case 'radio':
        return 'RadioEditor'
      default:
        return 'DefaultEditor'
    }
  }

  // Default Selected Values as of now are set in Cell Editors by searching via label displayed on table
  let columns = [...dataStructure.filter((val) => val.order?.table).sort((a,b)=>(a.order?.table > b.order?.table ? 1 : -1)).map((val) => (
    {
      headerName: val.tableHeader || val.label,
      field: ((val.field || val.label.replace(/ /g, '_').toLowerCase()).replace(/\./g, '') + (val.subFields || (val.type === "select" && !val.rootValue) ? val.subFields?.label || val.subFields?.name || "name" : "" )).replace(/\./g, ''),
      filter: val.type === 'number' ? 'agNumberColumnFilter' : (val.type === 'datepicker' ? 'agDateColumnFilter' : 'agTextColumnFilter'),
      editable: val.table?.editable || false,
      cellEditor: cellEditor(val.type),
      cellEditorPopup: val.type === 'checkbox' || val.type === 'select' || val.type === 'multiselect' || val.type === 'radio',
      valueGetter: (params) => valueGetter(params?.data || params, val),
      cellRendererFramework: (params) => val.table?.customRender ? val.table.customRender(valueGetter(params?.data || params, val), params) : valueGetter(params?.data || params, val),
      cellEditorParams: (params) => ({
        fieldName: getFN(val),
        values: val.type === 'datepicker' ? {
            options: val.table?.options,
            value: params.data[getFN(val)]
          } : val.type === 'select' || val.type === 'multiselect' || val.type === 'radio' ? {
            list: val.list,
            getRequest: val.getRequest,
            creatable: ((val.type === 'select' || val.type === 'multiselect') && val.table?.creatable) || false,
            type: val.type,
            rootValue: val.rootValue,
            subFields: val.subFields,
          } : val.type === 'mask' ? {
            mask: val.table?.mask
          } : val.type === 'switch' ? {
            list: val.list,
          } : {
            type: val.type
          }
      }),
      maxWidth: val.table?.maxWidth || null,
      minWidth: val.table?.minWidth || null,
      ...(val.table?.cellStyle ? { cellStyle: val.table.cellStyle } : {}),
    })),
  ]

  const data = dataList?.map((row) => {
    let tempRow = cloneDeep(row)
    dataStructure.filter((input) => input.order?.table).forEach((input) => {
      const field = input.subFields || (input.type === "select" && !input.rootValue) ? (input.subFields?.label || input.subFields?.name || input.type === "select" ? ((input.field || input.label.replace(/ /g, '_').toLowerCase()) + "." + (input.subFields?.label || input.subFields?.name || "name")) : (input.field || input.label.replace(/ /g, '_').toLowerCase())) : (input.field || input.label.replace(/ /g, '_').toLowerCase());
      let temp = get(tempRow,field)
      if(! (temp === false || temp === 0)){
        temp = temp || input.tableDefault || ""
      }
      set(tempRow, field.replace(/\./g, ''), temp)
    })
    return tempRow
  })

  const changeFilter = (e,k) => {
    if(filters[k].type === "dateRange"){
      const els = document.getElementsByClassName("flatpickr-calendar")
      let visible = false
      Array.from(els).forEach((e)=>{
        if(e.checkVisibility()){
          visible = true
        }
      })
      if(e.split(" to ").length > 1){
        setFilters(filters.map((f,key)=>{
          return key !== k ? f : {...f, value: e.split(" to ")}
        }))
      } else if(!visible){
        setFilters(filters.map((f,key)=>{
          return key !== k ? f : {...f, value: [e,e]}
        }))
      }
    } else if(filters[k].type === "date"){
      setFilters(filters.map((f,key)=>{
        return key !== k ? f : {...f, value: e}
      }))
    } else if(filters[k].type === "select"){
      setFilters(filters.map((f,key)=>{
        return key !== k ? f : {...f, value: f.list.filter((o)=>(parseInt(o.value) === parseInt(e.value) || o.value === e.value))[0]}
      }))
    }
  }
  
  // specify the data
  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    if(params.api){
      params.api.sizeColumnsToFit();
      window.addEventListener('resize', function () {
        setTimeout(function () {
          params.api.sizeColumnsToFit();
        });
      });
      params.api.sizeColumnsToFit();
    }
  };

  useEffect(() => {	
    if(! ovf){	
      setXsFData(data.filter(item=>{	
        let match = true	
        if(mobileSearchFilter.length > 0){	
          let filters = mobileSearchFilter.split(" ")	
          filters.filter(f=>f.length > 0).forEach(filter=>{	
            let innerMatch = false	
            columns.forEach((column)=>{	
              if(String(column.valueGetter(item)).toLowerCase().indexOf(String(filter).toLowerCase()) >= 0){	
                innerMatch = true	
              }	
            })	
            if(! innerMatch){	
              match = false	
            }	
          })	
        }	
        return match	
      }))	
    } else {	
      setXsFData(data)	
    }	
    // eslint-disable-next-line	
  }, [dataList, mobileSearchFilter])	
  useEffect(() => {	
    if(! ovf){	
      setSearchValue(mobileSearchFilter)	
    }	
    // eslint-disable-next-line
  }, [mobileSearchFilter])

  useEffect(()=>{
    let maxPages = Math.ceil(xsFData.length / xsPageSize)
    if(maxPages !== xsMaxPage){
      setXsCurrentPage(1)
    }
    setXsMaxPage(maxPages)
    // eslint-disable-next-line
  }, [xsFData])

  // Opened from the Customer Info page: prefill the create form from the passenger's submission.
  useEffect(() => {
    const info = location?.state?.customerInfo
    if(!info || actionsDisabled){
      return
    }
    const nameParts = String(info.full_name || '').trim().split(/\s+/).filter(Boolean)
    const lastName = nameParts.length > 1 ? nameParts.pop() : null
    const stay = String(info.place_of_stay || '').trim().toUpperCase()
    const hotel = stay ? addresses.data.find(a => a.label?.toUpperCase() === stay) : null
    caseFileCustomerInfoLink.id = info.id
    setCUModalConfig({ ...cuModalConfigRef.current, visible: true, type: "Create", size: "xl", typeKey: 0, preloadData: true, linkedCustomerInfo: info, data: {
      // Defaults to AHL (missing bag): changing the type later clears the flight, so set it up front.
      "type": "AHL",
      "flight_date": info.arrival_date,
      "flight": info.arrival_flight,
      "first_name": nameParts.join(" ").toUpperCase(),
      "last_name": lastName ? lastName.toUpperCase() : null,
      "address": hotel ? { id: hotel.value, name: hotel.label } : null,
      "departure_date": info.return_date || null,
      "courtesy": false,
      "bags": [{ "tag_number": "", "color_type": "", "received_weight": null, "bag_status": { id: 1, name: "TRACING" } }],
    }})
    history.replace({ ...location, state: undefined })
    // eslint-disable-next-line
  }, [location?.state?.customerInfo, actionsDisabled])

  const parseCaseFile = () => {
    let x = parseData
    const keys = ["File Reference Number", "File Type", "Number of bags", "Creation Date", "Names", "Given Name", "Title", "Address"]
    const fltStart = "Flight"
    const fltEnd = "Route"
    const fileRef = x.split(keys[0])?.[1]?.split("\n")?.[0].replace(":","").trim()
    const tmpType = x.split(keys[1])?.[1]?.split("\n")?.[0].replace(":","").trim()
    const fileType = tmpType === "Delayed" ? "AHL" : "AHL"
    const numberOfBags = x.split(keys[2])?.[1]?.split("\n")?.[0].replace(":","").trim()
    const fullName = ((x.split(keys[6])?.[1]?.split("\n")?.[0].replace(":","").trim() || "") + " " + (x.split(keys[5])?.[1]?.split("\n")?.[0].replace(":","").trim() || "") + " " + (x.split(keys[4])?.[1]?.split("\n")?.[0].replace(":","").trim() || "")).trim()
    const tmpAddress = x.split(keys[7])?.[1]?.split("\n")?.[0].replace(":","").trim()
    let address = addresses.data.filter(a=>a.label?.toUpperCase() === tmpAddress)[0] || ''
    address = address ? { id: address.value, name: address.label } : null

    const flt = x.split(fltStart)?.[1]?.split(fltEnd)?.[0].replace(":","").trim().split("\n")?.filter(f=>f.length > 0).map(i=>i.trim())
    const flight = flt?.[flt.length-1]?.split("/")?.[0].trim()
    let tmpDt = flt?.[flt.length-1]?.split("/")?.[1].trim()
    const flightDate = (moment(tmpDt + moment().year()).isAfter(moment()) ? moment(tmpDt + (moment().year()-1)) : moment(tmpDt + moment().year())).format("YYYY-MM-DD")
    let bags = []
    for(let i = 1; i <= numberOfBags; i++){
      x = x.substr(x.indexOf(`Bag ${i} details`))
      const bagColor = x.split("Color Type")?.[1]?.split("\n")?.[0].replace(":","").trim() || ""
      const tagNumber = x.split("Tag #")?.[1]?.split("\n")?.[0].replace(":","").trim() || ""
      bags.push({"tag_number": tagNumber, "color_type": bagColor, "received_weight": null, "bag_status": { id: 1, name: "TRACING" }})
    }
    
    const data = {
      "type": fileType,
      "file_reference": fileRef,
      "flight_date": flightDate,
      "flight": flight,
      "first_name": fullName,
      "last_name": null,
      "address": address,
      "courtesy": false,
      "bags": bags
    }
    setCUModalConfig({ ...cuModalConfig, visible: !cuModalConfig.visible, type: "Create", size: "xl", typeKey: 0, data: data, preloadData: true })
    setParseModalVisible(false)

  }

  
  const captureReceiptModalAsPdf = () => {
    const printArea = document.getElementById('dynamic-modal')
    if (!printArea) {
      return Promise.resolve(null)
    }
    const hidden = printArea.getElementsByClassName('print-hidden')
    Array.from(hidden).forEach((h) => { h.style.display = 'none' })
    return html2canvas(printArea)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const pdf = new jsPDF()
        pdf.addImage(imgData, 'PNG', 0, 0)
        return pdf
      })
      .catch((err) => {
        throw err
      })
      .finally(() => {
        Array.from(hidden).forEach((h) => { h.style.display = '' })
      })
  }

  const downloadReceiptPdf = () => {
    captureReceiptModalAsPdf()
      .then((pdf) => {
        if (!pdf) {
          notify({ status: 'error', message: 'Could not capture receipt.' })
          return
        }
        const ref = receiptModalData?.row?.primary_reference ?? receiptModalData?.row?.reference ?? 'case'
        pdf.save(`Receipt-${ref}.pdf`)
      })
      .catch(() => {
        notify({ status: 'error', message: 'Could not generate receipt PDF.' })
      })
  }

  const printReceiptPdf = () => {
    captureReceiptModalAsPdf()
      .then((pdf) => {
        if (!pdf) {
          notify({ status: 'error', message: 'Could not capture receipt.' })
          return
        }
        let blobUrl
        try {
          blobUrl = pdf.output('bloburl')
        } catch (e) {
          blobUrl = URL.createObjectURL(pdf.output('blob'))
        }
        const iframe = document.createElement('iframe')
        iframe.setAttribute('title', 'Receipt print')
        iframe.setAttribute('style', 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none')
        document.body.appendChild(iframe)
        const cleanup = () => {
          if (iframe.parentNode) {
            iframe.parentNode.removeChild(iframe)
          }
          if (blobUrl?.startsWith?.('blob:')) {
            URL.revokeObjectURL(blobUrl)
          }
        }
        iframe.onload = () => {
          try {
            const win = iframe.contentWindow
            if (win) {
              win.focus()
              win.print()
            }
          } catch (e) {
            notify({ status: 'error', message: 'Could not open the print dialog. Try Download and print the PDF instead.' })
          }
          setTimeout(cleanup, 120000)
        }
        iframe.src = blobUrl
      })
      .catch(() => {
        notify({ status: 'error', message: 'Could not generate receipt PDF.' })
      })
  }

  const linkedCustomerInfoBanner = cuModalConfig.type === "Create" && cuModalConfig.linkedCustomerInfo ? (
    <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 8, padding: "8px 12px", fontSize: "0.9rem" }}>
      <i className="mdi mdi-card-account-details-outline" style={{ color: "#0ea5e9", fontSize: "1.1rem" }} />
      <span>Linked Customer Info:</span>
      <button type="button" className="btn btn-link p-0 font-weight-bold" style={{ fontWeight: 700 }} onClick={() => setCustomerInfoPopup(cuModalConfig.linkedCustomerInfo)} title="View submitted details">
        {cuModalConfig.linkedCustomerInfo.reference}
      </button>
      <span className="text-muted">(click to view details)</span>
    </div>
  ) : null
  const DModal = <DynamicModal id="tester" config={cuModalConfig} toggleModal={toggleCUModal} submitModes={formModes} ds={dataStructure} banner={linkedCustomerInfoBanner} />
  const CFViewModal = (
    <CaseFileViewModal
      isOpen={caseFileViewOpen}
      toggle={closeCaseFileView}
      row={caseFileViewRow}
      footerActions={
        caseFileViewRow ? (
          <ActionButtons
            key={caseFileViewRow.id}
            actions={getFilteredCaseFileActions(caseFileViewRow).filter((a) => a.label !== "View")}
            type="buttons"
            row={caseFileViewRow}
            grouped
            showLabels
            actionsDisabled={actionsDisabled}
            printName={`Receipt-${caseFileViewRow.reference}`}
            customHeader={`Case File | {rowlabel} | ${caseFileViewRow.reference} - ${caseFileViewRow.flight} - ${caseFileViewRow.type}`}
          />
        ) : null
      }
    />
  )

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Row>
            <Col xs={12} md={4}>
              <h3>
                {isDashboard ? "Received Files" : models}{" "}
                  {HasPermission("create") && !isDashboard ? (
                    <>
                      <Button disabled={actionsDisabled} color='primary' className='ml-2 waves-effect waves-light' type='submit' onClick={() => toggleCUModal({ mode: "Create", print: false, size: "xl" })}>
                        <i className='mdi mdi-plus d-block font-size-12'></i>
                      </Button>
                      &nbsp;&nbsp;
                      <Button disabled={actionsDisabled} color='info' className='ml-2 waves-effect waves-light' type='submit' onClick={() => toggleParseModal()}>
                        <i className='mdi mdi-pencil-plus d-block font-size-12'></i>
                      </Button>
                    </>
                  ) : null}
                </h3>
            </Col>
            <Col xs={12} md={8} align="right">
              {filters && filters.length > 0 && !isDashboard ? (
                <Row>
                  {filters.map((filter, key)=>(
                    <Col key={key} xs={12} md={filter.size || 6} className={filter.offset ? `offset-md-${filter.offset}` : ''}>
                      <Row>
                      <Col className="d-none d-md-block mt-2" xs={12} md={3}>
                        <Label>{filter.label}</Label>
                      </Col>
                      <Col className="d-block d-md-none mt-2" xs={12} md={3} align="left">
                        <Label>{filter.label}</Label>
                      </Col>
                      <Col xs={12} md={9} align="left">
                      {filter.type === "date" ? (
                          <Flatpickr onChange={(_,e) => changeFilter(e,key)} placeholder="Select..." options={mergeOperationalDateCaps({ altInput: true, defaultDate: filter.value })} value={filter.value} className="form-control d-block" />
                        ) : null}
                        {filter.type === "dateRange" ? (
                          <Flatpickr onChange={(_,e) => changeFilter(e,key)} placeholder="Select..." options={mergeOperationalDateCaps({ mode:'range', altInput: true, defaultDate: filter.value })} value={filter.value} className="form-control d-block" />
                        ) : null}
                        {filter.type === "select" ? (
                          <Select onChange={(e) => changeFilter(e,key)} placeholder="Select..." options={filter.list} value={filter.value} />
                        ) : null}
                      </Col></Row>
                    </Col>
                  ))}
                </Row>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              {!(breakPoint === 'xs' || breakPoint === 'sm') ? (
                <Card className='d-none d-md-block'>
                  <CardBody>
                    <Loader loading={tableLoading} />
                    <Row>
                      <Col xs={6}>
                        <div style={{display: 'flex', justifyContent: 'left'}}>	
                          <input value={searchValue} onKeyPress={(e)=>{	
                            if(e.key === 'Enter' && ovf){	
                              setLastAPIActionTime(new Date())	
                            }	
                          }} type="text" className="form-control" onChange={(e)=>{	
                            if(!ovf){	
                              gridApi.setQuickFilter(e.target.value);	
                              setGridApi(gridApi)	
                            }	
                            setSearchValue(e.target.value)	
                          }} placeholder="Search..." style={{ maxWidth:"400px", marginBottom:"15px" }} />	
                          {ovf ? (	
                            <>&nbsp;&nbsp;&nbsp;<Button style={{maxHeight:'38px'}} color='primary' className='btn-sm waves-effect waves-light' onClick={()=>setLastAPIActionTime(new Date())}>Search All</Button></>	
                          ) : null}	
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center', gap: '4px' }}>
                          {selectedRow ? (
                            <React.Fragment>
                              {renderActions(selectedRow?.data, false, false, true)}
                              <Button disabled={actionsDisabled} color='primary' className='btn-sm waves-effect waves-light' style={{marginLeft:'5px'}} type='submit' onClick={()=>{
                                if(gridApi.getSelectedNodes().length > 0){
                                  gridApi.getSelectedNodes()[0].setSelected(false)
                                }
                              }}>
                                <i className='mdi mdi-close d-block font-size-12'></i>
                              </Button>
                            </React.Fragment>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div className={themeType === 'dark' ? "ag-theme-alpine-dark" : "ag-theme-alpine"} style={{height: '650px'}}>
                        <AgGridReact
                            frameworkComponents={{
                              renderActions: renderActions,
                              SelectEditor: SelectEditor,
                              DefaultEditor: DefaultEditor,
                              MaskEditor: MaskEditor,
                              DateTimeEditor: DateTimeEditor,
                              RadioEditor: RadioEditor,
                              CheckboxEditor: CheckboxEditor,
                              SwitchEditor: SwitchEditor,
                            }}
                            // editType="fullRow"
                            onSelectionChanged={()=>{
                              setSelectedRow(gridApi.getSelectedNodes()[0] || false)
                            }}
                            onRowDoubleClicked={(e) => openCaseFileView({ row: e.data })}
                            defaultColDef={defaultColDef}
                            onGridReady={onGridReady}
                            rowHeight={55}
                            rowStyle={{border: 'none'}}
                            animateRows={true}
                            pagination={true}
                            paginationPageSize={10}
                            rowData={data}
                            getRowNodeId={(data)=>data.id}
                            columnDefs={columns}
                            rowSelection="single"
                          >
                        </AgGridReact>
                    </div>
                  </CardBody>
                </Card>
              ) : (
                <div className="d-block d-md-none mt-2">
                  <Loader loading={tableLoading} />
                  <div className="d-block d-md-none" style={{display: 'flex', justifyContent: 'left'}}>	
                    <div style={{display: 'flex', justifyContent: 'left'}}>	
                      <input value={mobileSearchFilter} type="text" className="form-control" onKeyPress={(e)=>{	
                          if(e.key === 'Enter' && ovf){	
                            setLastAPIActionTime(new Date())	
                          }	
                        }} onChange={(e)=>{	
                          setMobileSearchFilter(e.target.value)	
                        }} placeholder="Search..." style={{ maxWidth:"315px", marginBottom:"15px" }} />	
                        {ovf ? (	
                          <>&nbsp;&nbsp;&nbsp;<Button style={{maxHeight:'38px', minWidth:'58px'}} color='primary' className='btn-sm waves-effect waves-light' onClick={()=>setLastAPIActionTime(new Date())}>Search</Button></>	
                        ) : null}	
                    </div>	
                  </div>
                  {xsFData.slice(((xsCurrentPage-1) * xsPageSize), (xsCurrentPage * xsPageSize)).map((item, key)=>(
                    <Card key={key} className='border border-primary'>
                      <CardTitle className='text-center bg-primary pt-2 pb-2 text-white'>{item[columns[0]?.field]}</CardTitle>
                        <CardBody className='pt-0 pb-0'>
                          {columns.map((column, ck) => (
                            ck > 0 ? <CardText key={ck} className="mb-2"><span style={{fontWeight:600}}>{column.headerName}: </span><span className={themeType === 'dark' ? 'text-white' : 'text-primary'}>{column.valueGetter(item)}</span></CardText> : null
                          ))}
                        </CardBody>
                      <ButtonGroup>
                        {dataList.length > 0 ? renderActions(item, false, xsActions, true) : null}
                      </ButtonGroup>
                    </Card>
                  ))}
                  <ButtonGroup style={{display:"flex"}}>
                    <Button disabled={xsCurrentPage <= 1} onClick={()=>setXsCurrentPage(1)} color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-double-left d-block font-size-16'></i>
                    </Button>
                    <Button disabled={xsCurrentPage <= 1} onClick={()=>setXsCurrentPage((c)=>--c)} color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-left d-block font-size-16'></i>
                    </Button>
                    <Button color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <Input style={{maxWidth:"50px"}} type="text" value={xsCurrentPage} onClick={(e)=>e.target.setSelectionRange(0, e.target.value.length)} onChange={(e)=>{
                        if(parseInt(e.target.value) > 0 && parseInt(e.target.value) <= xsMaxPage){
                          e.target.blur()
                          setXsCurrentPage(parseInt(e.target.value))
                        }
                      }} />
                    </Button>
                    <Button color='info' className='btn-md waves-effect waves-light'>
                      of
                    </Button>
                    <Button color='info' className='btn-md waves-effect waves-light'>
                      {xsMaxPage}
                    </Button>

                    <Button disabled={xsCurrentPage >= xsMaxPage} onClick={()=>setXsCurrentPage((c)=>++c)} color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-right d-block font-size-16'></i>
                    </Button>
                    <Button disabled={xsCurrentPage >= xsMaxPage} onClick={()=>setXsCurrentPage(xsMaxPage)} color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-double-right d-block font-size-16'></i>
                    </Button>
                  </ButtonGroup>
                </div>
              )}
            </Col>
          </Row>

          <Modal size="lg" isOpen={parseModalVisible} toggle={()=>toggleParseModal()} keyboard={false} backdrop="static">
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="myModalLabel">Read Case File</h5>
              <button type="button" onClick={() => toggleParseModal()} className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div id="modalBody" className="modal-body">
              <Input type="textarea" rows="20" value={parseData} onChange={(e)=>setParseData(e.target.value)} />
            </div>
            <div className="modal-footer">
              <button type="button" onClick={() => toggleParseModal()} className="btn btn-secondary waves-effect" data-dismiss="modal">Close</button>
              <button type="button" onClick={() => parseCaseFile()} className="btn btn-primary waves-effect" data-dismiss="modal">Continue</button>
            </div>
                  
          </Modal>

          {DModal}
          {CFViewModal}
          <CustomerInfoModal info={customerInfoPopup} isOpen={!!customerInfoPopup} toggle={() => setCustomerInfoPopup(null)} />
          {bulkCaseAction?.type === 'receive' && (
            <CaseFileReceiveAllModal
              caseFile={bulkCaseAction.row}
              themeType={themeType}
              onClose={closeBulkCaseAction}
              onSuccess={onBulkCaseActionSuccess}
            />
          )}
          {bulkCaseAction?.type === 'forward' && (
            <CaseFileForwardAllModal
              caseFile={bulkCaseAction.row}
              forwardTypeOptions={forwardTypeOptions}
              themeType={themeType}
              onClose={closeBulkCaseAction}
              onSuccess={onBulkCaseActionSuccess}
            />
          )}
          {bulkCaseAction?.type === 'deliver' && (
            <CaseFileDeliverAllModal
              caseFile={bulkCaseAction.row}
              themeType={themeType}
              onClose={closeBulkCaseAction}
              onSuccess={onBulkCaseActionSuccess}
            />
          )}

          <ConfirmDialog id={confirmID} params={confirmParams} config={confirmConfig} visible={confirmModalVisible} toggleModal={toggleConfirmModal} />

          <Modal isOpen={mailAirlineModalVisible} toggle={closeMailAirlineModal} keyboard={false} backdrop="static">
            <div className="modal-header">
              <h5 className="modal-title mt-0">Mail airline{mailAirlineRow?.primary_reference ? ` — ${mailAirlineRow.primary_reference}` : ''}</h5>
              <button type="button" onClick={closeMailAirlineModal} className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Label className="mb-2">Message to appear before the case details (optional)</Label>
              <Input type="textarea" rows="8" value={mailAirlineCustomMessage} onChange={(e) => setMailAirlineCustomMessage(e.target.value)} placeholder="Add a note or context for the airline…" />
            </div>
            <div className="modal-footer">
              <Button color="secondary" onClick={closeMailAirlineModal}>Cancel</Button>
              <Button color="primary" onClick={sendMailAirline}>Send</Button>
            </div>
          </Modal>

          
          <Modal size="lg" isOpen={receiptModalVisible} toggle={()=>toggleReceiptModal({})} keyboard={false} backdrop="static" id="dynamic-modal">
              <div className="modal-header print-hidden">
                  <h5 className="modal-title mt-0" id="myModalLabel">Receipt | {receiptModalData?.row?.primary_reference}</h5>
                  <button type="button" onClick={() => toggleReceiptModal({})} className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div id="modalBody" className="modal-body" style={{margin:"10px"}}>
                  <Row align="center">
                    <Col>
                      <img src={logo} alt="" width="30%" />
                      <p></p>
                      <h5><b>Baggage Services Office</b></h5>
                      <h6>Velana International Airport</h6>
                      <p></p>
                      <h6 style={{lineHeight:'10px'}}><b>Telephone: </b>+960 3315366</h6>
                      <h6 style={{lineHeight:'10px'}}><b>Email: </b>lostnfound@macl.aero</h6>
                    </Col>
                  </Row>
                  <Row align="center" style={{marginTop:"10px", border:'1px solid black'}}>
                      <Col>
                        <h3 style={{margin:0, padding: 10}}>{receiptModalData?.row?.type === "DPR" ? "DAMAGED PROPERTY REPORT" : "LOST PROPERTY REPORT"}</h3>
                      </Col>
                  </Row>
                  <Row style={{marginTop:"30px"}}>

                    <Col xs={12} md={6}>
                      <Col xs={6}>
                        <b>Claim Reference</b>
                      </Col>
                      <Col xs={6} style={{marginBottom:"10px"}}>
                        <span>{receiptModalData?.row?.primary_reference}</span>
                      </Col>

                      <Col xs={6}>
                        <b>Name</b>
                      </Col>
                      <Col xs={6} style={{marginBottom:"10px"}}>
                        <span>{receiptModalData?.row?.full_name}</span>
                      </Col>

                      <Col xs={6}>
                        <b>Flight Date</b>
                      </Col>
                      <Col xs={6} style={{marginBottom:"10px"}}>
                        <span>{receiptModalData?.row?.flight_date ? moment(receiptModalData?.row?.flight_date).format("Do MMMM, YYYY") : "-"}</span>
                      </Col>

                      <Col xs={6}>
                        <b>Type</b>
                      </Col>
                      <Col xs={6} style={{marginBottom:"10px"}}>
                        <span>{receiptModalData?.row?.type}</span>
                      </Col>

                    </Col>
                    
                    <Col xs={12} md={6}>
                      <Col xs={6}>
                        <b>Bags (received / total)</b>
                      </Col>
                      <Col xs={6} style={{marginBottom:"10px"}}>
                        <span>{Number(receiptModalData?.row?.number_of_received_bags ?? 0)}/{Number(receiptModalData?.row?.number_of_bags ?? 0)}</span>
                      </Col>
                                              
                      <Col xs={6}>
                        <b>Address</b>
                      </Col>
                      <Col xs={6} style={{marginBottom:"10px"}}>
                        <span>{receiptModalData?.row?.address?.name}</span>
                      </Col>
                      
                      <Col xs={6}>
                        <b>Flight Number</b>
                      </Col>
                      <Col xs={6} style={{marginBottom:"10px"}}>
                        <span>{receiptModalData?.row?.flight}</span>
                      </Col>
                      
                      <Col xs={6}>
                        <b>Status</b>
                      </Col>
                      <Col xs={6} style={{ marginBottom: "10px", display: "flex", alignItems: "center", gap: "6px" }}>
                        {receiptModalData?.row?.closed ? (
                          <i className="mdi mdi-lock-outline" title="Closed case" aria-hidden style={{ fontSize: "18px", color: "#6b7280" }} />
                        ) : null}
                        <span>
                          {receiptModalData?.row?.case_status}
                          {receiptModalData?.row?.closed ? <span style={{ opacity: 0.85 }}> (closed)</span> : null}
                        </span>
                      </Col>
                    </Col>
                  </Row>
                  
                  <Row align="center" style={{marginTop:"10px", border:'1px solid black'}}>
                      <Col>
                        <h6 style={{margin:0, padding: 10}}>Please note that this Report does not involve any acknowledgement of liability.</h6>
                      </Col>
                  </Row>

                  <Row style={{marginTop:"20px"}}>
                    <Col>
                      <span><b>Generate On: </b>{moment().format("dddd, MMMM D, YYYY | HH:mm:ss [(Local Time)]")}</span>
                    </Col>
                  </Row>
              </div>
              <div className="print-hidden modal-footer">
                  <button type="button" onClick={() => toggleReceiptModal({})} className="btn btn-secondary waves-effect" data-dismiss="modal">Close</button>
                  <button type="button" onClick={() => printReceiptPdf()} className="btn btn-outline-primary waves-effect">Print</button>
                  <button type="button" onClick={() => downloadReceiptPdf()} className="btn btn-primary waves-effect">Download</button>
              </div>
          </Modal>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(CaseFiles);
